import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { serviceTypes } from 'utils/constants/serviceTypes';
import { getUserRoles } from 'reducers/users';
import { ManagerAndAbove, userHasRole } from 'utils/helper/roles';
import { SecurityColumns } from './columns';
import securityForm from './form';
import { filters as securityFilters } from './filters';
import { TASK_MODEL } from 'services/entity/task';
import { actions as dataGridActions } from './Modules/dataGridTable';
import { cloneTaskInitialValues } from '../../../Task/Form/options';
import { transformTaskFormValues } from 'utils/DataTransform/Task/taskForm';
import BaseSecurities from './Layouts/baseSecurities';
import SecurityDetails from './securityDetails';
import { PAGE_URLS } from 'utils/constants';
import { detailOpenState } from 'reducers/ui';

const Task = ({ isTemplate = false, editable = true }) => {
  const userRoles = useSelector(state => getUserRoles(state));
  const loading = useSelector(state => state.ui.loading);
  const detailOpen = useSelector(state => detailOpenState(state));
  const defaultFilterValues = {
    taskCategory: [serviceTypes.security],
  };

  // Action
  const dispatch = useDispatch();
  const dispatchUpdateTaskAction = useCallback(
    ({ data }) => {
      dispatch(dataGridActions.updateRowEntry({ data }));
    },
    [dispatch],
  );

  const onChange = ({ id, value, task, selected }) => {
    if (!selected.isDummyTask) {
      const data = {
        tasks: [
          {
            id,
            [TASK_MODEL.assignee.id]: value.id,
            [TASK_MODEL.assigneeFullName.id]: value.name,
            [TASK_MODEL.assigneeImageUrl.id]: value.photoUrl,
            [TASK_MODEL.taskType.id]: selected.taskType,
          },
        ],
      };
      dispatchUpdateTaskAction({ data });
      return;
    }

    const parentTaskType = task?.tasks.find(f => f.id === id);
    // eslint-disable-next-line no-unused-vars
    const { id: newID, ...newFormInitial } = cloneTaskInitialValues({
      taskToCloneId: id,
      taskToCloneDetails: task,
      allowSubTask: true,
      defaultValues: {
        isTemplate: selected.isTemplate,
        taskType: parentTaskType?.taskType,
      },
    });

    const data = transformTaskFormValues({
      values: {
        ...newFormInitial,
        isTemplate: false,
        schedule: selected.schedule,
        schedulePatterns: undefined,
        assigneeId: {
          id: value.id,
          name: value.name,
        },
        multiSchedule: false,
        allowSubTask: true,
      },
    });
    dispatchUpdateTaskAction({ data });
  };

  const SecurityDetailsComponent = useCallback(
    ({ id, selected, ...props }) => {
      return (
        <SecurityDetails
          id={id}
          selected={selected}
          {...props}
          onChange={onChange}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <BaseSecurities
      editable={editable}
      cols={SecurityColumns}
      downloadable={userHasRole({
        userRoles: userRoles,
        requiredRoles: ManagerAndAbove,
      })}
      defaultFilterValues={defaultFilterValues}
      isTemplate={isTemplate}
      filters={securityFilters}
      filtersRequired={true}
      FormComponent={securityForm}
      DetailComponent={SecurityDetailsComponent}
      loading={loading}
      persistentStateName={PAGE_URLS.SECURITY_TASKS.name}
      forceOpenDetailPanel={detailOpen[PAGE_URLS.SECURITY_TASKS.link]}
    />
  );
};
Task.propTypes = {
  clearCleanerTaskDetails: PropTypes.func,
  updateTask: PropTypes.func,
  isTemplate: PropTypes.bool,
  editable: PropTypes.bool,
};

export default Task;
